export default __webpack_public_path__ + "static/media/valley10.50bc640a.png";